import React from 'react';
import logo from './logo.svg';
import './App.css';
import ImprovedEnterpriseLayoutPreview from './Layout/main_layout';
import LoginInterface from './login-interface';
import { Route, Routes, Navigate } from 'react-router-dom';
import { authService } from 'api/services';
import ProtectedRoute from './components/auth/ProtectedRoute';

const LoginOrHome = () =>
  authService.isAuthenticated() ? <Navigate to="/app" replace /> : <LoginInterface />;

function App() {
  return (


    <Routes>
        <Route path="/" element={<LoginOrHome />} />
        <Route path="/login" element={<LoginOrHome />} />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <ImprovedEnterpriseLayoutPreview />
            </ProtectedRoute>
          }
        />
        {/* other routes */}
      </Routes>
    // <ImprovedEnterpriseLayoutPreview/>
  );
}

export default App;
